module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_start_guanghuan2.2b5af.png";